import React, { useMemo } from 'react';
import { Box, Card, CardMedia, CardContent, Typography, Grid as MuiGrid } from '@mui/material';
import { useDashboard } from '../../../contexts/DashboardContext';

export default function DashboardGrid({ panelId, outputKey = 'grid_data', config }) {
  const { getSlice } = useDashboard();
  const raw = getSlice(panelId, outputKey);

  const items = useMemo(() => {
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : raw?.items ?? [];
    return arr.map((item, i) => ({
      id: item.id ?? item._id ?? i,
      title: item.title ?? item.name ?? '',
      subtitle: item.subtitle ?? item.description ?? '',
      image: item.image ?? item.imageUrl ?? item.img ?? null,
      link: item.link ?? item.url ?? null,
    }));
  }, [raw]);

  if (!items.length) {
    return (
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 200 }}>
        <Typography color="text.secondary">No grid data. Use chat or refresh to run a flow.</Typography>
      </Box>
    );
  }

  const columns = Math.max(config?.columns ?? 2, 1);

  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <MuiGrid container spacing={2}>
        {items.map((item) => (
          <MuiGrid item xs={12} sm={12 / Math.min(columns, 4)} key={item.id}>
            <Card
              sx={{
                height: '100%',
                cursor: item.link ? 'pointer' : 'default',
                textDecoration: 'none',
                color: 'inherit',
                display: 'block',
              }}
              component={item.link ? 'a' : 'div'}
              href={item.link || undefined}
            >
              {item.image && (
                <CardMedia
                  component="img"
                  height="140"
                  image={item.image}
                  alt={item.title}
                  sx={{ objectFit: 'cover' }}
                />
              )}
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  {item.title}
                </Typography>
                {item.subtitle && (
                  <Typography variant="body2" color="text.secondary">
                    {item.subtitle}
                  </Typography>
                )}
              </CardContent>
            </Card>
          </MuiGrid>
        ))}
      </MuiGrid>
    </Box>
  );
}
